import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

const toDate = (ts) => (ts?.toDate ? ts.toDate() : ts ? new Date(ts) : new Date(0));

const fetchAllBlogs = async () => {
  const q = query(collection(db, 'blogs'), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getPublishedBlogs = async () => {
  const all = await fetchAllBlogs();
  return all
    .filter(b => b.published)
    .sort((a, b) => toDate(b.publishedAt) - toDate(a.publishedAt));
};

export const getBlogBySlug = async (slug) => {
  const all = await fetchAllBlogs();
  return all.find(b => b.slug === slug && b.published) || null;
};

export const getBlogsByCategory = async (category) => {
  const all = await fetchAllBlogs();
  return all
    .filter(b => b.published && b.category === category)
    .sort((a, b) => toDate(b.publishedAt) - toDate(a.publishedAt));
};

export const getRelatedBlogs = async (category, excludeSlug, limit = 3) => {
  const all = await getBlogsByCategory(category);
  return all.filter(b => b.slug !== excludeSlug).slice(0, limit);
};
